import PropTypes from 'prop-types';
import React, {useState, useEffect} from 'react';

import LogoPsr from '../LogoPsr/LogoPsr';
import './PsrBox.style.scss';

export const PsrBox = (props) => {
  const [selected, setSelected] = useState(false);

  // Sincroniza estado local com estado global para evitar duplicação
  useEffect(() => {
    const isSelected = props.psrsSelectedGroup.some(
      (psr) => psr.id === props.psr.id
    );
    setSelected(isSelected);
  }, [props.psrsSelectedGroup, props.psr.id]);

  const unselectPsr = () =>
    props.psrsSelectedGroup.filter((psr) => psr.id !== props.psr.id);

  const selectPsr = () => [...props.psrsSelectedGroup, props.psr];

  const setOptions = () => {
    let psrList = [];

    if (!selected) {
      psrList = selectPsr();
    } else {
      psrList = unselectPsr();
    }

    props.setPsrGroupSelected(psrList);
  };

  return (
    <button
      type="button"
      onClick={() => setOptions()}
      className={`options-psr ${selected ? 'psr-selected' : ''}`}
      id={`psr-id-${props.psr.name.toLowerCase()}`}
      data-testid={`psr-id-${props.psr.name.toLowerCase()}`}
      data-aut-test={`psr-id-${props.psr.name.toLowerCase()}`}
    >
      <LogoPsr psrId={props.psr.id} psrName={props.psr.name} />
    </button>
  );
};

PsrBox.propTypes = {
  psr: PropTypes.object,
  psrsSelectedGroup: PropTypes.array,
  setPsrGroupSelected: PropTypes.func
};
